/**
 * Combien de temps un message reste a l'ecran, en millisecondes.
 *
 * Tous disparaissaient en 3,2 secondes, quelle que soit leur longueur. C'est assez pour
 * « C'est noté », pas pour les trois phrases qui expliquent qu'une demande est refusee :
 * combien, quand ca revient, ce qui reste possible. Une porte fermee dont on n'a pas eu
 * le temps de lire l'explication est une porte fermee sans explication.
 *
 * Un message court garde donc sa duree d'avant ; au-dela, soixante-dix millisecondes par
 * caractere — le pas d'une lecture tranquille sur un telephone. Quinze secondes au plus :
 * rien ne doit s'incruster, et un appui sur le message le ferme de toute facon.
 */
const DUREE_MINIMALE_MS = 3200;
const DUREE_MAXIMALE_MS = 15_000;
const MS_PAR_CARACTERE = 70;

export function dureeDAffichage(texte: string): number {
  return Math.min(DUREE_MAXIMALE_MS, Math.max(DUREE_MINIMALE_MS, texte.length * MS_PAR_CARACTERE));
}
